module.exports = __webpack_public_path__ + "img/23_116.49e63daf.png";